import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const certificationsReducer = createAsyncReducer({
    name: 'certifications',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadById: create.asyncThunk(
            async (certId) => {
                return Fetch.get(Routes.ajax_certification_path(certId));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        )
    })
});

export default certificationsReducer;